
// Variabili dati FAQ
const vsFaqData = [
  {
    category: "vs",
    title: "Differenze",
    icon: "https://cdn.shopify.com/s/files/1/0330/9430/3880/files/differences-01.svg?v=1751916927",
    questions: [
      {
        icon: "https://cdn.shopify.com/s/files/1/0330/9430/3880/files/differences-circle-01.svg?v=1751942862",
        question: "Qual è la differenza tra la Carbon Edition e la Black Edition Q Follow?",
        answer: "In termini di caratteristiche e prestazioni, non c'è differenza. La differenza sta nell'aspetto del Q Follow. La Black Edition presenta passaruota, maniglia, nervatura posteriore e sottoscocca in nero opaco, mentre la Carbon Edition presenta gli stessi componenti con finitura in carbonio."
      },
      {
        icon: "https://cdn.shopify.com/s/files/1/0330/9430/3880/files/QvX_circle-01.svg?v=1751942862",
        question: "Qual è la differenza tra Q Follow e X10 Follow?",
        answer: "<strong>Il Q Follow</strong> è costruito su un telaio completamente nuovo con design più compatto (40-65% meno ingombro da chiuso), maniglia centrale, stabilizzatore automatico, batteria SmartPower Bluetooth e altri miglioramenti (accessori, impugnatura, ecc.)."
      }
    ]
  },
  {
    category: "technical",
    title: "Tecnico",
    icon: "https://cdn.shopify.com/s/files/1/0330/9430/3880/files/technical-01.svg?v=1751916928",
    questions: [
      {
        icon: "https://cdn.shopify.com/s/files/1/0330/9430/3880/files/follow_circle-01.svg?v=1751943196",
        question: "Come funziona il sistema Follow?",
        answer: "Due antenne creano zone attiva e neutra. Quando il telecomando è nella zona attiva (1-3m), il carrello segue automaticamente il giocatore regolando la velocità dei motori."
      },
      {
        icon: "https://cdn.shopify.com/s/files/1/0330/9430/3880/files/cruise_circle-01.svg?v=1751943197",
        question: "Posso impostare la velocità di camminata?",
        answer: "Sì. Tramite i pulsanti numerati del telecomando puoi impostare la velocità desiderata."
      }
    ]
  },
  {
    category: "battery",
    title: "Batteria",
    icon: "https://cdn.shopify.com/s/files/1/0330/9430/3880/files/battery-01.svg?v=1751916928",
    questions: [
      {
        icon: "https://cdn.shopify.com/s/files/1/0330/9430/3880/files/battery_circle-01.svg?v=1751943577",
        question: "Quanto durerà la batteria?",
        answer: "307Wh = oltre 2 round di golf. I consumi dipendono da percorso, stile di gioco, peso sacca. L'app SmartPower ti mostra il residuo esatto."
      },
      {
        icon: "https://cdn.shopify.com/s/files/1/0330/9430/3880/files/battery_circle-01.svg?v=1751943577",
        question: "Con quale frequenza devo caricarla?",
        answer: "Consigliamo di caricarla dopo ogni round. Lo stato si controlla anche tramite app."
      }
    ]
  },
  {
    category: "clean",
    title: "Pulizia e utilizzo",
    icon: "https://cdn.shopify.com/s/files/1/0330/9430/3880/files/clean-01.svg?v=1751916927",
    questions: [
      {
        icon: "https://cdn.shopify.com/s/files/1/0330/9430/3880/files/clean_circle-01.svg?v=1751943817",
        question: "Come lo pulisco?",
        answer: "Rimuovi residui con aria o panno. Lucida con prodotto per mobili. Evita l'acqua diretta."
      }
    ]
  },
  {
    category: "delivery",
    title: "Consegna",
    icon: "https://cdn.shopify.com/s/files/1/0330/9430/3880/files/delivery-01.svg?v=1751916928",
    questions: [
      {
        icon: "https://cdn.shopify.com/s/files/1/0330/9430/3880/files/delivery_circle-01.svg?v=1751944212",
        question: "Quanto tempo ci vuole per la consegna nel Regno Unito?",
        answer: "In 24h lavorative con DPD (escluse zone remote). Notifiche automatiche e tracciamento incluso."
      }
    ]
  },
  {
    category: "returns",
    title: "Resi & Rimborsi",
    icon: "https://cdn.shopify.com/s/files/1/0330/9430/3880/files/returns-01.svg?v=1751916927",
    questions: [
      {
        icon: "https://cdn.shopify.com/s/files/1/0330/9430/3880/files/returns_circle-01.svg?v=1751943817",
        question: "Qual è la vostra politica sui resi?",
        answer: "Hai 14 giorni per restituire il Q Follow se non sei soddisfatto. Rimborso completo."
      }
    ]
  }
];

// Mostra popup FAQ
function openFaq(category) {
  const popup = document.getElementById('vsFaqPopup');
  const sidebar = document.getElementById('vsFaqSidebar');
  const content = document.getElementById('vsFaqContent');

  // Pulisce sidebar e contenuti
  sidebar.innerHTML = '';
  content.innerHTML = '';

  const section = vsFaqData.find(sec => sec.category === category);
  if (!section) return;

  // Sidebar
  // Prima rimuovo eventuali classi active
document.querySelectorAll('.vs-faq-sidebar-item').forEach(el => {
  el.classList.remove('active');
});

// Ricrea la sidebar
vsFaqData.forEach(sec => {
  const item = document.createElement('div');
  item.className = 'vs-faq-sidebar-item';
  item.innerHTML = `
    <img src="${sec.icon}" alt="${sec.title}">
    <span>${sec.title}</span>
  `;
  item.onclick = () => {
    // Rimuovi classe active da tutti gli elementi
    document.querySelectorAll('.vs-faq-sidebar-item').forEach(el => {
      el.classList.remove('active');
    });
    item.classList.add('active');
    openFaq(sec.category);
  };
  // Se è la sezione attiva, aggiungi subito classe
  if (sec.category === category) {
    item.classList.add('active');
  }
  sidebar.appendChild(item);
});



  // Titolo e contenuto
  const heading = document.createElement('h2');
  heading.textContent = section.title;
  content.appendChild(heading);

  section.questions.forEach(q => {
    const block = document.createElement('div');
    block.className = 'vs-faq-question';
    block.innerHTML = `
      <h3><img src="${q.icon}" alt="">${q.question}</h3>
      <p>${q.answer}</p>
    `;
    content.appendChild(block);
  });

  popup.classList.add('open');
}

// Chiudi popup
function vsCloseFaq() {
  document.getElementById('vsFaqPopup').classList.remove('open');
}

// Listener su icone iniziali
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".vs-faq-grid-item").forEach(item => {
    item.addEventListener("click", () => {
      const category = item.dataset.category;
      openFaq(category);
    });
  });
});
